exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-main-page-js": () => import("./../../../src/pages/main-page.js" /* webpackChunkName: "component---src-pages-main-page-js" */),
  "component---src-pages-mobile-page-js": () => import("./../../../src/pages/mobile-page.js" /* webpackChunkName: "component---src-pages-mobile-page-js" */)
}

